import { atom } from 'jotai';

import { Recipient } from 'api/api';

export const isSameAsDeliveryCheckboxCheckedAtom = atom(false);

export const prefilledBillingAddressAtom = atom<Recipient | undefined>(undefined);
